<template>
	<div class="page with-logo">
		<div class="logo"></div>
		<h1>
			Thanks!
		</h1>
		<p>
			We have sent you a confirmation email with your promotion details.
		</p>
		<p>
			If you have any questions please contact us <a href="mailto:backstage@ents24.com" target="_blank">here</a>.
		</p>
		<router-link class="start button large gradient sunset" to="/">Create new promotion</router-link>
	</div>
</template>

<script>
	export default {
	}
</script>
